<template>
  <el-tooltip
    :content="darkMode ? '切换为日间模式' : '切换为黑夜模式'"
    placement="bottom"
  >
    <button
      type="button"
      class="page-theme-toggle"
      :aria-label="darkMode ? '日间模式' : '黑夜模式'"
      @click="toggleDarkMode"
    >
      <i :class="darkMode ? 'el-icon-sunny' : 'el-icon-s-opportunity'" />
    </button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'ThemeToggle',
  computed: {
    darkMode() {
      return this.$store.state.setting.darkMode;
    },
  },
  methods: {
    toggleDarkMode() {
      this.$store.dispatch('setting/toggleDarkMode');
    },
  },
};
</script>

<style lang="less" scoped>
.page-theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  color: #606266;
  font-size: 18px;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, border-color 0.2s;

  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background: #ecf5ff;
  }
}
</style>
